<template>
  <el-drawer
    :title="title"
    size="55%"
    :with-header="true"
    :visible="drawer"
    v-on:update:visible="$emit('update:drawer', $event)"
    @closed="handleClosed"
    :before-close="handleDrawerClose"
  >
    <el-container direction="vertical">
      <el-main>
        <el-row :gutter="20">
          <el-col>
            <el-form
              ref="el_form"
              :model="model"
              label-position="left"
              size="mini"
              label-width="120px"
            >
              <el-form-item label-width="0" prop="Content">
                <quill-editor
                  ref="myQuillEditor"
                  v-model="model.Content"
                  :options="editorOption"
                />
              </el-form-item>

              <el-form-item label-width="0">
                <el-upload
                  ref="upload_files"
                  action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
                  accept="image/png, image/jpeg"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess"
                  :on-error="handleUploadError"
                  :file-list="fileList"
                >
                  <i class="el-icon-upload"></i>
                </el-upload>

                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
              </el-form-item>

              <el-form-item label="" label-width="0">
                <el-button type="primary" @click="onSubmit" v-loading="loading"
                  >{{ button_submit_text }}
                </el-button>
                <el-button @click="$emit('update:drawer', false)"
                  >Cancelar</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "MessageFormDrawer",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Crear mensaje"
    },
    messageId: {
      type: Number,
      required: false,
      default: 0
    },
    action: {
      type: String,
      default: "create"
    }
  },
  components: {
    "quill-editor": quillEditor
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image"]
          ]
        }
      },
      model: {
        UpdatedAt: null,
        UpdatedBy: undefined,
        Content: "",
        CountLike: 0,
        Images: [],
        Likes: [],
        CreatedAt: "",
        CreatedBy: 0,
        Id: null,
        CompanySelected: null,
        MotiveForDeletion: null
      },
      dialogImageUrl: "",
      dialogVisible: false,
      loading: false,
      button_submit_text: "Crear"
    };
  },
  created() {
    if (this.action === "edit" && this.messageId > 0) {
      const message = this.getMessage(this.messageId);
      this.model.Id = this.messageId;
      this.model.Content = message.Content;
      this.model.Images = message.Images;
      this.model.CreatedAt = message.CreatedAt;

      this.button_submit_text = "Actualizar";
    }

    if (this.action === "create") {
      this.button_submit_text = "Crear";
    }

    this.model.CreatedBy = this.currentUser.UserID;
    this.model.UpdatedBy = this.currentUser.UserID;
    this.model.CompanySelected = this.currentCompany;
  },
  methods: {
    ...mapActions({
      createMessage: "message/create",
      updateMessage: "message/update"
    }),
    handleClosed() {
      // clear form
      this.$refs.el_form.resetFields();
      this.$refs.upload_files.clearFiles();
      this.model = {
        UpdatedAt: null,
        UpdatedBy: undefined,
        Content: "",
        CountLike: 0,
        Images: [],
        Likes: [],
        CreatedAt: null,
        CreatedBy: 0,
        Id: null,
        CompanySelected: null,
        MotiveForDeletion: null
      };
    },
    onSubmit() {
      this.$refs.el_form.validate((valid) => {
        if (valid) {
          if (this.model.Content === "") {
            this.$message.error("Contenido del mensaje requerido");
            return false;
          }

          this.loading = true;
          if (this.action === "create") {
            this.createMessage({ new_message: this.model })
              .then(() => {
                this.$emit("update:drawer", false);
                this.handleClosed();
                this.$message.success("Mensaje creado");
              })
              .catch((error) => {
                console.error(error);
                this.$emit("update:drawer", false);
                this.handleClosed();
                this.$message.error("Error al crear mensaje");
              })
              .finally(() => {
                this.loading = false;
              });
          } else if (this.action === "edit") {
            this.updateMessage({ update_message: this.model })
              .then(() => {
                this.$emit("update:drawer", false);
                this.handleClosed();
                this.$message.success("Mensaje actualizado");
              })
              .catch((error) => {
                console.error(error);
                this.$emit("update:drawer", false);
                this.handleClosed();
                this.$message.error("Error al actualizar mensaje");
              })
              .finally(() => {
                this.loading = false;
              });
          }
        } else {
          return false;
        }
      });
    },
    handleRemove(file) {
      return this.$confirm("Seguro de eliminar " + file.name + "?");
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res) {
      res.forEach((i) => {
        this.model.Images.push({ Src: i.Url });
      });
    },
    handleUploadError(_, file) {
      this.$message.error(`Error al cargar - ${file.name}`);
    },
    handleDrawerClose(done) {
      this.$confirm("Segura/o que desea salir, sus cambios seran borrador ?")
        .then(() => {
          done();
        })
        .catch(() => {});
    }
  },
  computed: {
    ...mapGetters({ getMessage: "message/getMessageId" }),
    fileList() {
      return this.model.Images.length > 0
        ? this.model.Images.map((image) => ({
            url: image.Src,
            name: "name.png"
          }))
        : [];
    }
  },
  watch: {
    messageId(val) {
      if (this.messageId > 0) {
        const message = this.getMessage(val);
        this.model.Id = val;
        this.model.Content = message.Content;
        this.model.Images = message.Images;
        this.model.CreatedAt = message.CreatedAt;
      }
    },
    action(v) {
      if (v === "edit") {
        this.button_submit_text = "Actualizar";
      } else if (v === "create") {
        this.button_submit_text = "Crear";
      }
    }
  }
};
</script>

<style></style>
